// DenseBoard.js — Feature 2 (2026-09-07): dense desktop view for many
// blocks. Layout: rows = blocked accounts, columns = the four moderation
// lists. Each account row has a RADIO group (one list per account — the
// moderation model); selecting a list adds the account to it, deselecting
// removes it (via the website's existing remove path).

import React from 'react';
import { LIST_DEFS } from '../lib/lists';

const DenseBoard = ({ blocks, columns, onAdd, onRemove, busy }) => {
  // listName -> Set of dids currently in that list
  const membership = {};

  for (const def of LIST_DEFS) {
    membership[def.name] = new Set(
      (columns.find((c) => c.name === def.name)?.items ?? []).map((i) => i.subject?.did)
    );
  }

  const currentListFor = (did) =>
    LIST_DEFS.find((def) => membership[def.name].has(did))?.name ?? '';

  const handleChange = (block, listName) => {
    const previous = currentListFor(block.did);

    if (listName === previous) {
      // Same radio re-selected: no-op.
      return;
    }

    if (previous) {
      // Account is in another list — remove it there first (one-list model).
      const prevCol = columns.find((c) => c.name === previous);
      const item = prevCol?.items.find((i) => i.subject?.did === block.did);

      if (item) onRemove(item, previous);
    }

    if (listName) {
      onAdd(block, listName);
    }
  };

  return (
    <div className="dense-board" aria-label="Dense view — choose a list per account">
      <div className="dense-header">
        <span className="dense-corner">{blocks.length} accounts</span>
        {LIST_DEFS.map((def) => (
          <span key={def.name} className="dense-col-head">
            {def.name}
          </span>
        ))}
      </div>
      {blocks.map((block) => {
        const current = currentListFor(block.did);

        return (
          <div key={block.did} className="dense-row">
            <span className="dense-account" title={block.handle || block.did}>
              {block.displayName || block.handle || block.did}
            </span>
            {LIST_DEFS.map((def) => {
              const checked = current === def.name;

              return (
                <label
                  key={def.name}
                  className={`dense-cell${checked ? ' member' : ''}`}
                  aria-label={`${block.handle || block.did} in ${def.name}: ${checked ? 'member' : 'not a member'}`}
                >
                  <input
                    type="radio"
                    name={`list-${block.did}`}
                    value={def.name}
                    checked={checked}
                    onChange={() => handleChange(block, def.name)}
                    disabled={busy}
                  />
                </label>
              );
            })}
          </div>
        );
      })}
      {busy && <p className="status-line">Working...</p>}
    </div>
  );
};

export default DenseBoard;
